import { useState, useCallback } from "react";

// V28: Manages contextual first-use hints — each shows once per user
export function useHints(userId) {
  const [visibleHint, setVisibleHint] = useState(null);

  const showHint = useCallback((hintId, condition = true) => {
    if (!userId || !condition) return false;
    // Don't show if already showing another hint
    if (visibleHint && visibleHint !== hintId) return false;
    // Don't show if already dismissed
    const key = `hint_shown_${hintId}_${userId}`;
    try { if (localStorage.getItem(key)) return false; } catch(_) { return false; }
    // Don't show hints to users with >7 days of data
    try {
      const firstLog = localStorage.getItem(`first_log_date_${userId}`);
      if (firstLog) {
        const daysSince = (Date.now() - new Date(firstLog).getTime()) / 86400000;
        if (daysSince > 7) return false;
      }
    } catch(_) {}
    setVisibleHint(hintId);
    return true;
  }, [userId, visibleHint]);

  const dismissHint = useCallback((hintId) => {
    if (!userId) return;
    const key = `hint_shown_${hintId}_${userId}`;
    try { localStorage.setItem(key, "1"); } catch(_) {}
    setVisibleHint(null);
  }, [userId]);

  const isVisible = useCallback((hintId) => visibleHint === hintId, [visibleHint]);

  return { showHint, dismissHint, isVisible };
}
